import { useMutation } from '@tanstack/react-query';

import { request, getUrlToBackendApi } from '@shared/services/api';

import { UserType } from '@types';

const REQUEST_URL = '/profile';

type RequestBody = {
	steam_trade_url: string;
};

type ResponseType = {
	status: string;
	data: UserType;
};

export const useMutationAttachTradeLink = () => {
	return useMutation<UserType, Error, RequestBody>({
		mutationFn: async ({ steam_trade_url }: RequestBody) => {
			const response = await request<ResponseType>({
				method: 'put',
				url: getUrlToBackendApi(REQUEST_URL).href,
				data: {
					steam_trade_url: steam_trade_url
				}
			});
			return response.data;
		}
	});
};
